import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CommonModal } from "@app/components/modals/CommonModal";
import { PaymentMethodModalSchema } from "@app/components/modals/PaymentModal/paymentMethodModalSchema";
import {
  ModalProps,
  ModalContent,
  createModalComponent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Separator,
  DialogFooter,
  DialogClose,
  Button,
  useModal,
} from "@shortsworks/ui";
import {
  useRegisterPaymentMethod,
  useGetAccountPlatform,
  useGetAccountPaymentMethod,
} from "@shortsworks/user-api";
import { useQueryClient } from "@tanstack/react-query";

interface PostingSelectorModalProps {
  title?: string;
  description?: string;
}

const PaymentMethodContent = <T = any, R = []>(
  props: ModalProps<PostingSelectorModalProps, string[]>,
) => {
  const { showModal } = useModal();

  const queryClient = useQueryClient();
  const { data: accountPlatformData, isSuccess: isSuccessGetAccountPlatform } =
    useGetAccountPlatform();
  const { queryKey: getAccountPaymentMethodQueryKey } =
    useGetAccountPaymentMethod();
  const registerPaymentMethod = useRegisterPaymentMethod({
    mutation: {
      onSuccess: () => {
        return queryClient.invalidateQueries({
          queryKey: getAccountPaymentMethodQueryKey,
        });
      },
    },
  });

  // 타입 지정 필요
  const { form, schemas, parseForm } = useFormWithSchema({
    formSchemas: PaymentMethodModalSchema,
    mode: "onChange",
    defaultFormValues: {
      "cardType": "personal"
    }
  });

  const handleRegisterPaymentMethod = async () => {
    if (!isSuccessGetAccountPlatform) {
      return showModal(CommonErrorModal, {
        title: "회원 정보를 불러오는데 실패했습니다.",
      });
    }
    const parsedForm = parseForm();
    if (!parsedForm.success) {
      return;
    }

    const { cardPassword, cardExpiration, cardNumber, customerBirthday } =
      parsedForm.data;
    // @ts-ignore
    const { email, name } = accountPlatformData.data;

    const [cardExpirationMonth, cardExpirationYear] =
      cardExpiration.match(/.{2}/g);

    try {
      const result = await registerPaymentMethod.mutateAsync({
        data: {
          cardPassword,
          cardExpirationMonth,
          cardExpirationYear,
          cardNumber,
          customerBirthday,
          customerEmail: email,
          customerName: name,
        },
      });

      if (!result.data.success) {
        return showModal(CommonErrorModal, {
          title: "카드 등록에 실패했습니다.",
        });
      }

      showModal(CommonModal, { title: "카드가 추가되었습니다." });
      props.close();
    } catch (error) {
      // 에러 메세지 형태로 변경 필요
      return showModal(CommonErrorModal, { title: error });
    }
  };

  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>카드 등록</DialogTitle>
      </DialogHeader>
      <FormContainer className="mt-2" schemas={schemas} form={form} />
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button onClick={handleRegisterPaymentMethod} className="p-0 w-24 h-10">
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};
export const PaymentMethodModal = createModalComponent(PaymentMethodContent);
